import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

export interface IceBreakerTemplate {
  id: string;
  label: string;
  body: string;
  mvpRef?: string;
}

interface IceBreakerPickerProps {
  templates: IceBreakerTemplate[];
  onSelect: (body: string) => void;
  visible: boolean;
}

/**
 * FEAT-068 (MVP-18.9) — selectable ice-breaker templates for new conversations.
 */
const IceBreakerPicker: React.FC<IceBreakerPickerProps> = ({
  templates,
  onSelect,
  visible,
}) => {
  if (!visible || templates.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }} data-testid="ice-breaker-picker">
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Start with an ice-breaker (you can edit before sending):
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {templates.map((template) => (
          <Chip
            key={template.id}
            label={template.label}
            clickable
            variant="outlined"
            onClick={() => onSelect(template.body)}
            data-testid={`ice-breaker-${template.id}`}
          />
        ))}
      </Box>
    </Box>
  );
};

export default IceBreakerPicker;
